// Created / adapted custom implementations of methods available from lodash and deepmerge as they were adding nearly
//  180kb to the generated lib files

// Solution found here: https://stackoverflow.com/a/37616104/400699
function filterObject(object, predicate) {
  if (typeof object === 'undefined') {
    return {}
  } else {
    return Object.keys(object)
      .filter(function (key) { return predicate(key, object[key]); })
      .reduce(function (result, key) { return ((result[key] = object[key]), result); }, {})
  }
}

function omit(object, keys) {
  return filterObject(object, function (key) { return keys.indexOf(key) === -1; })
}

var InheritSlots = {
  props: {
    inheritDefaultSlot: {
      type: Boolean,
      default: false
    },
    inheritParentSlots: {
      type: Boolean,
      default: true
    },
    element: {}
  },
  functional: true,
  render: function render(h, context) {
    // pull in the context.slots() in case the user wants to merge these with the parent slots
    var allSlots = context.slots();

    // if scopedSlots were passed in, parent scopedSlots will be merged into this hash
    var scopedSlots = context.data.scopedSlots;

    if (!scopedSlots) {
      context.data.scopedSlots = {};
      scopedSlots = context.data.scopedSlots;
    }

    var ref = context.props;
    var inheritDefaultSlot = ref.inheritDefaultSlot;
    var inheritParentSlots = ref.inheritParentSlots;
    var element = ref.element;
    if (!element) {
      element = context.data.tag;
    }

    var parentSlots = [];
    if (inheritParentSlots) {
      var parent = context.parent;
      parentSlots = inheritDefaultSlot
        ? parent.$slots
        : omit(parent.$slots, ['default']);
      Object.entries(parentSlots).forEach(function (ref) {
        var slotName = ref[0];
        var slots = ref[1];

        allSlots[slotName] = slots.concat(allSlots[slotName] || []);
      });
      var parentScopedSlots = parent.$scopedSlots || {};
      if (!inheritDefaultSlot) {
        parentScopedSlots = omit(parentScopedSlots, ['default']);
      }
      Object.entries(parentScopedSlots).forEach(function (ref) {
        var key = ref[0];
        var value = ref[1];

        scopedSlots[key] = value;
      });
    }

    var slotChildren = [];
    Object.entries(allSlots).forEach(function (ref) {
      var slotName = ref[0];
      var slots = ref[1];

      slotChildren.push(
        h(
          'template',
          {
            slot: slotName
          },
          slots
        )
      );
    });
    if (element) {
      return h(
        element,
        Object.assign({}, context.data, {scopedSlots: scopedSlots}),
        slotChildren
      )
    } else {
      return slotChildren
    }
  }
};

var VueInheritSlotsPlugin = {
  install: function install(Vue, options) {
    if ( options === void 0 ) options = {};

    Vue.component(options.alias || 'InheritSlots', InheritSlots);
  }
};

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueInheritSlotsPlugin);
}

export default VueInheritSlotsPlugin;
export { InheritSlots };
